import React, { useState, Fragment } from "react";
import { useSelector } from "react-redux";
import { apiRequest } from "services/apiRequest";
import { requestType } from "services/requests";
import moment from 'moment';
import Swal from 'sweetalert2'
import Loader from "utilities/reusableComponent/Loader/Loader";

function PupilRequest({data, refreshTeacherRequest, setRefreshTeacherRequest}) {
  const { userInfo } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  // const [selectedUid, setSelectedUid] = useState(null);

  const handleRequestAtion = async(child_uid, action) => {
    setLoading(true);
    // setSelectedUid(child_uid);

    const response = await apiRequest({
      requestType: requestType.requestTeacherAction,
      payload: {
        data: {
          user_uid: userInfo?.uid,
          uid: child_uid,
          action: action
        }
      },
    });
    if (response?.data?.status === 0) {
      setRefreshTeacherRequest(refreshTeacherRequest + 1);
    } else {
      // show error popup meesage when register is failed
      const swalFailedMessage = Swal.mixin({
        customClass: {
          popup: 'swal-failed-popup',
          confirmButton: "swal-success",
          title: 'swal-title',
        },
        buttonsStyling: false,
      });
      swalFailedMessage.fire({
        title: "Failed!",
        html: `<p class='swal-text-html'>${response.data.error_message}</p>`,
        imageWidth: 65,
        imageHeight: 60,
        confirmButtonText: "Close",
      });
    }
    setLoading(false);
    // setSelectedUid(null);
  }

  return (
    <Fragment>
      <div className="max-w-screen-lg mx-auto rounded-t-[80px] bg-custom-blue mt-[-80px] pb-[100px]">
        <div className="pt-[50px] px-[50px] pb-[100px] w-full">
          <h1 className="font-gluten font-bold text-4xl text-white">
            Pupil Request <span className="text-yellow">({data.length})</span>
          </h1>
          <div className="grid grid-cols-2 gap-[50px] mt-[50px]">
            {data.map((item, index) => {
              return (
                <div
                  key={index}
                  className="pb-[0px] flex items-start overflow-hidden"
                >
                  <div className="w-[60px] h-[60px] rounded-full border-[2px] border-custom-navy bg-white overflow-hidden mr-[25px] flex-shrink-0">
                    <img
                      src={item.avatar}
                      className="w-full h-full object-contain"
                      alt=""
                    />
                  </div>
                  <div className="flex flex-col gap-[18px] overflow-hidden">
                    <div className="flex items-center">
                      <h4 className="text-2xl text-white font-bold">
                        {item.name}
                      </h4>
                    </div>
                    <p className="text-[22px] truncate ... w-full text-white leading-7 tracking-[0.44px]">
                      {item.request_message}
                    </p>
                    <p className="text-lg text-white uppercase tracking-[2.34px] opacity-[0.6]">{moment(item.datetime).format('DD/MM/YYYY HH:mmA')}</p>
                    <div className="flex gap-[9px] mt-[7px] w-full">
                      <div 
                        className="bg-custom-green rounded-[100px] w-1/2 flex items-center justify-center text-white text-2xl cursor-pointer"
                        onClick={() => handleRequestAtion(item.uid, "accept")}
                      >
                        Accept
                      </div>
                      <div 
                        className="bg-custom-navy rounded-[100px] h-[45px] w-1/2 flex items-center justify-center text-white text-2xl cursor-pointer"
                        onClick={() => handleRequestAtion(item.uid, "decline")}
                      >
                        Decline
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {loading && <Loader />}
    </Fragment>
  );
}

export default PupilRequest;
